module.exports = __webpack_public_path__ + "static/media/dog.7b8f012d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/dog.svg
// module id = 61
// module chunks = 0